import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {RightSidebarActionButton} from "../../../layout/rightSidebar/RightSidebarRail";
import {ServerTableExportDialog} from "../export/ServerTableExportDialog";
import {type ServerTableExportOptions, useServerTableExport} from "../export/useServerTableExport";

export type ServerTableRailExportProps<TRequest> = ServerTableExportOptions<TRequest>;

/**
 * The rail's Export action, next to Print: CSV or Excel of the list as the API renders it (the live search, filters
 * and sort, one row per guest of a group). The button opens `ServerTableExportDialog` for the format, the columns and
 * the row count, and spins while the file is made. The API must know the list (crqlar-api-v3
 * `service/export/list/`); read-only users cannot export.
 */
export function ServerTableRailExport<TRequest>(props: ServerTableRailExportProps<TRequest>) {
    const {t} = useTranslation();
    const {disabled, running, columns, visibleColumnIds, pageRowCount, pageOffset, totalRowCount, run} = useServerTableExport(props);
    const [open, setOpen] = useState(false);

    return (
        <>
            <RightSidebarActionButton
                icon={running ? <CircularProgress size={20} color="inherit"/> : <FileDownloadOutlinedIcon/>}
                label={t("Export")}
                disabled={disabled || Boolean(running)}
                onClick={() => setOpen(true)}
            />

            <ServerTableExportDialog
                open={open}
                onClose={() => setOpen(false)}
                title={props.title}
                columns={columns}
                visibleColumnIds={visibleColumnIds}
                pageRowCount={pageRowCount}
                pageOffset={pageOffset}
                totalRowCount={totalRowCount}
                onExport={(format, options) => void run(format, options)}
            />
        </>
    );
}
